export default __webpack_public_path__ + "static/media/ic_replay.990f1d31.svg";